import helper from "@/config/helper";
import Vue from "vue";

const toastrOptions = {
	position: "top",
};

const initialState = () => ({
	store_name:			null,
	store_url:			null,
	merchant_number:	null,
	subscription_id:	null,
	order_number:		null,
	amount:				null,
	status:				null,

	last_feedback:		null,
	customer_taxid:		null,
	billing_date:		null,
	next_billing_date:	null,
	skipped:			null,
	can_edit_item:		null,
	history:			[],
	payment_methods:	null,
	available_cards:	[],

	billing_cycle: {
		quantidade:	null,
		intervalo:	null,
	},
	pix_rec_id:		null,
	current_card: {
		cc_bin:		null,
		cc_brand:	null,
		prev_saved:	null,
	},
	merchant_options: {
		allow_subscription_edit:	null,
		cancel_button:	null,
		pause_enabled:	null,
		pause_text:		null,
		skip_enabled:	null,
		skip_text:		null,
	},

	single_products:		[],
	subscription_products:	[],

	editing_single_products:		[],
	editing_subscription_products:	[],
});

const state = initialState();

const actions = {
	async getSubscription({ state, commit, rootGetters }){
		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("merchant_number",	state.merchant_number);
		data.append("subscription_id",	state.subscription_id);
		data.append("method",			"getSubscription");

		return await helper
			.axios()
			.post("", data)
			.then((response) => {
				let data = response.data;
				commit("setInformation", data);
			})
			.catch((error) => {
				helper.callback_error(error);
			});
	},

	updateSubscriptionName({ state, commit, rootGetters }) {
		const credentials = rootGetters['auth/getCredentials'];

		const data = new FormData();

		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("subscription_id",	state.subscription_id);
		data.append("merchant_number",	state.merchant_number);
		data.append("custom_name", state.custom_name);
		data.append("method", "updateSubscriptionName");

		helper
			.axios()
			.post("", data)
			.then((response) => {
				if (response.status === 200) {
					Vue.$toast.success("Nome de assinatura salvo com sucesso.", { position: "top" });

					commit("modals/setDialogSubscriptionEdit", false, { root: true });
				}
			})
			.catch((error) => {
				helper.callback_error(error);
			});
	},

	async getCurrentProducts({ state, commit, rootGetters }){
		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("merchant_number",	state.merchant_number);
		data.append("subscription_id",	state.subscription_id);
		data.append("method",			"getCurrentProducts");

		return await helper
			.axios()
			.post("", data)
			.then((response) => {
				let data = response.data;
				commit("setProducts", data);
			})
			.catch((error) => {
				helper.callback_error(error);
			});
	},

	updateProducts({ commit, dispatch, state, rootGetters }){
		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",				credentials.email);
		data.append("code",					credentials.code);
		data.append("token",				credentials.token);
		data.append("merchant_number",		state.merchant_number);
		data.append("subscription_id",		state.subscription_id);
		data.append("method",				"updateProducts");
		data.append("products",				JSON.stringify(state.editing_subscription_products));
		data.append("next_billing_products",JSON.stringify(state.editing_single_products));

		commit("setLoading", true, { root: true });

		helper
			.axios()
			.post("", data)
			.then(() => {
				commit("updateProducts");
				commit("modals/setDialogEditProducts", false, { root: true });
				dispatch("analytics/setFeedback", "edit_subscription", { root: true });
				Vue.$toast.success("Assinatura atualizada com sucesso.", toastrOptions);
			})
			.catch((error) => {
				helper.callback_error(error, "Falha ao atualizar a assinatura.");
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	},
}

const mutations = {
	startDetail(state, content){
		state.custom_name		= content.custom_name		?? null;
		state.store_name		= content.store_name		?? null;
		state.store_url			= content.store_url			?? null;
		state.merchant_number	= content.merchant_number	?? null;
		state.subscription_id	= content.subscription_id	?? null;
		state.order_number		= content.order_number		?? null;
		state.amount			= content.amount			?? null;
		state.status			= content.status			?? null;
	},

	resetDetail(state){
		Object.assign(state, initialState());
	},

	setInformation(state, content){
		state.status			= content.status;
		state.amount			= content.amount;
		state.last_feedback		= content.last_feedback;
		state.customer_taxid	= content.customer_taxid;
		state.billing_date		= content.billing_date;
		state.next_billing_date	= content.next_billing_date;
		state.skipped			= content.skipped;
		state.can_edit_item		= content.can_edit_item;
		state.history			= content.history;
		state.payment_methods	= content.payment_methods;
		state.available_cards	= content.available_cards;
		state.pix_rec_id		= content.pix_rec_id;

		state.current_card.cc_bin		= content.current_card?.cc_bin;
		state.current_card.cc_brand		= content.current_card?.cc_brand;
		state.current_card.prev_saved	= content.current_card?.prev_saved;

		state.billing_cycle.quantidade	= content.billing_cycle?.quantidade;
		state.billing_cycle.intervalo	= content.billing_cycle?.intervalo;

		state.merchant_options.allow_subscription_edit 	= content.merchant_options?.allow_subscription_edit;
		state.merchant_options.cancel_button 			= content.merchant_options?.cancel_button;
		state.merchant_options.pause_enabled 			= content.merchant_options?.pause_enabled;
		state.merchant_options.pause_text	 			= content.merchant_options?.pause_text;
		state.merchant_options.skip_enabled	 			= content.merchant_options?.skip_enabled;
		state.merchant_options.skip_text	 			= content.merchant_options?.skip_text;
	},

	setProducts(state, content){
		state.single_products = [...content.single_products];
		state.subscription_products = [...content.subscription_products];

		state.editing_single_products = content.single_products.map(product => ({...product}));
		state.editing_subscription_products =  content.subscription_products.map(product => ({...product}));
	},

	resetEditingProducts(state){
		state.editing_single_products = state.single_products.map(product => ({...product}));
		state.editing_subscription_products =  state.subscription_products.map(product => ({...product}));
	},

	updateProducts(state){
		state.single_products = [...state.editing_single_products];
		state.subscription_products = [...state.editing_subscription_products];
	},

	deleteProduct(_, [editingList, index]){
		editingList.splice(index, 1);
	},

	incrementQuantity(_, [editingList, index]){
		editingList[index].quantity++;
	},

	decrementQuantity(_, [editingList, index]){
		if(editingList[index].quantity == 1) {
			return;
		}
		editingList[index].quantity--;
	},

	toggleHistoryItem(state, index){
		state.history[index].open = !state.history[index].open;
	},

	setLastFeedback(state, content){
		state.last_feedback = content;
	},

	setPixRecId(state, content){
		state.pix_rec_id = content;
	},

	setPrevSaved(state, content){
		state.current_card.prev_saved = content;
	},

	setStatus(state, content){
		state.status = content;
	},

	setSkipped(state, content){
		state.skipped = content;
	},

	setNextBillingDate(state, content){
		state.next_billing_date = content;
	},

	setSubscriptionId(state, content) {
		state.subscription_id = content;
	},

	setMerchantNumber(state, content) {
		state.merchant_number = content;
	},

	setSubscriptionName(state, content) {
		state.custom_name = content;
	}
}

const getters = {
	getMerchantNumber(state){
		return state.merchant_number;
	},

	getSubscriptionId(state){
		return state.subscription_id;
	},

	subscriptionAmount(state){
		let total = 0;

		state.subscription_products.forEach((product) => {
			const productAmount = (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
			total += Number(productAmount);
		});

		return total;
	},

	subscriptionAmountWithoutDiscount(state){
		let total = 0;

		state.subscription_products.forEach((product) => {
			const productAmount = (product.amount * product.quantity).toFixed(2);
			total += Number(productAmount);
		});

		return total;
	},

	editingTotal(state){
		let total = 0;

		state.editing_subscription_products.forEach((product) => {
			const productAmount = (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
			total += Number(productAmount);
		});

		state.editing_single_products.forEach((product) => {
			const productAmount = (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
			total += Number(productAmount);
		});

		return total.toFixed(2);
	},

	currentTotal(state) {
		let total = 0;

		if (!state.subscription_products.length) {
			return total;
		}

		state.subscription_products.forEach((product) => {
			const productAmount = (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
			total += Number(productAmount);
		});

		state.single_products.forEach((product) => {
			const productAmount = (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
			total += Number(productAmount);
		});

		return total.toFixed(2);
	},

	hasDiscount(state) {
		return state.subscription_products.some(product => product.discount > 0);
	},

	hasShipping(state) {
		const hasShipping = (product) => product.category_id == 1;
		return state.subscription_products.some(hasShipping) || state.single_products.some(hasShipping);
	},

	shippingAmount(state) {
		let amount = 0;

		state.subscription_products.forEach((product) => {
			if(product.category == 'Frete'){
				const productAmount = (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
				amount += Number(productAmount);
			}
		});

		state.single_products.forEach((product) => {
			if(product.category == 'Frete'){
				const productAmount = (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
				amount += Number(productAmount);
			}
		});

		return amount.toFixed(2);
	},

	calculateProductAmount: (_) => (product) => {
		return (product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
	},

	calculateProductDiscount: (_) => (product) => {
		return (product.amount * product.quantity - product.amount * (1 - (product.discount ?? 0) / 100) * product.quantity).toFixed(2);
	},

	productsWithoutShipping: (_) => (products) => {
		return products.filter((product) => product.category_id != 1);
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};